import { createFileRoute, useNavigate } from "@tanstack/react-router";
import ResetPasswordWithEmailCode from "@/components/auth/reset-password";
import {
  AuthLeftPanel,
  AuthMobileLogo,
  AuthRightPanel,
} from "@/components/auth/auth-layout";

export const Route = createFileRoute("/_public/auth/reset-password")({
  component: ResetPasswordPage,
});

function ResetPasswordPage() {
  const navigate = useNavigate();

  const handleCancel = () => {
    navigate({ to: "/auth/sign-in" });
  };

  return (
    <div className="flex min-h-screen flex-col lg:flex-row">
      <AuthLeftPanel
        headline="Recupera el acceso a tu cuenta"
        subtitle="Restablece tu contraseña de forma segura y vuelve a gestionar tus envíos en minutos."
        badge="Recuperar acceso"
      />

      <AuthRightPanel>
        <AuthMobileLogo />
        <ResetPasswordWithEmailCode
          handleCancel={handleCancel}
          provider="password"
        />
      </AuthRightPanel>
    </div>
  );
}
